import {
  UPDATE_STACK_LIST,
  STACK_DELETE,
  STACK_DELETE_SUCCESS,
  STACK_DELETE_ERROR,
  UPDATE_STACK_FILTER_OPTIONS,
  SIGNAL_STACK_LIST_LOADING,
  UPDATE_ARCHIVE_DOWNLOAD_PROGRESS,
  SIGNAL_STACK_COORDINATES_LOADING,
  UPDATE_STACK_COORDINATES,
  UPDATE_STACK_MAP_INFO,
  UpdateStackMeasurementCard,
  UPDATE_STACK_MEASUREMENT_CARD,
  UPDATE_ACCUMULATED_CSV_DOWNLOAD_PROGRESS,
  UPDATE_ACCUMULATED_CSV_DOWNLOAD_ALL_PROGRESS,
} from '../store/stacks';
import { UPDATE_STACK, STACK_ERROR } from '../store/stack';
import { ApiService } from 'services/apiService';
import { notificationActions } from 'actions/notificationActions';
import {
  DownloadAccumulatedFromFilterRequest,
  ListStacksResponseItemPaginatedResponse,
  MeasurementCardResponse,
  StackFilterOptionsQueryRequest,
  StackFilterOptionsResponse,
  StackQueryRequest,
  StacksBySawmillQueryPagedRequest,
} from '.generated/api';
import { ApplicationState, AppDispatch } from 'store';
import { IStackQuery } from '../store/models/IStackQuery';

export const stackActions = {
  getOrganizationMeasurementCard,
  getStacks,
  getStackFilterOptions,
  getStacksForSawmillUser,
  refreshStacks,
  getStackById,
  deleteStackById,
  downloadStackArchive,
  downloadAccumulatedCsv,
  downloadAllAccumulatedCsv,
  getStackMapInfoById,
};

function downloadStackArchive(stackIds: string[]) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_ARCHIVE_DOWNLOAD_PROGRESS,
      progress: -1,
    });

    ApiService.downloadStackArchive(stackIds, (progressEvent) => {
      if (progressEvent.loaded && progressEvent.total) {
        dispatch({
          type: UPDATE_ARCHIVE_DOWNLOAD_PROGRESS,
          progress: Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          ),
        });
      }
    })
      .then((response) => {
        const blobby = response.data;

        let filename = 'archive.zip';

        const contentDispositionHeader =
          response.headers['content-disposition'];
        if (contentDispositionHeader) {
          if (
            contentDispositionHeader &&
            contentDispositionHeader.indexOf('attachment') !== -1
          ) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDispositionHeader);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }
        }

        const objectUrl = window.URL.createObjectURL(blobby);
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.href = objectUrl;
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(anchor);

        dispatch({
          type: UPDATE_ARCHIVE_DOWNLOAD_PROGRESS,
        });
      })
      .catch((error) => {
        dispatch(notificationActions.enqueueErrorResponse(error));
        dispatch({
          type: UPDATE_ARCHIVE_DOWNLOAD_PROGRESS,
        });
      });
  };
}

function downloadAccumulatedCsv(measurementCardId: string, stackIds: string[]) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_PROGRESS,
      progress: -1,
    });

    ApiService.downloadAccumulatedCSV(
      measurementCardId,
      stackIds,
      (progressEvent) => {
        if (progressEvent.loaded && progressEvent.total) {
          dispatch({
            type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_PROGRESS,
            progress: Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            ),
          });
        }
      },
    )
      .then((response) => {
        const blobby = response.data;

        let filename = 'accumulated.csv';

        const contentDispositionHeader =
          response.headers['content-disposition'];
        if (contentDispositionHeader) {
          if (
            contentDispositionHeader &&
            contentDispositionHeader.indexOf('attachment') !== -1
          ) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDispositionHeader);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }
        }

        const objectUrl = window.URL.createObjectURL(blobby);
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.href = objectUrl;
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(anchor);

        dispatch({
          type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_PROGRESS,
        });
      })
      .catch((error) => {
        dispatch(notificationActions.enqueueErrorResponse(error));
        dispatch({
          type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_PROGRESS,
        });
      });
  };
}

function downloadAllAccumulatedCsv(
  measurementCardId: string,
  filters: StackQueryRequest,
) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_ALL_PROGRESS,
      progress: -1,
    });

    const request: DownloadAccumulatedFromFilterRequest = {
      ...filters,
      measurementCardId,
    };

    ApiService.downloadAccumulatedCSVFromFilter(request, (progressEvent) => {
      if (progressEvent.loaded && progressEvent.total) {
        dispatch({
          type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_ALL_PROGRESS,
          progress: Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          ),
        });
      }
    })
      .then((response) => {
        const blobby = response.data;

        let filename = 'accumulated.csv';

        const contentDispositionHeader =
          response.headers['content-disposition'];
        if (contentDispositionHeader) {
          if (
            contentDispositionHeader &&
            contentDispositionHeader.indexOf('attachment') !== -1
          ) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDispositionHeader);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }
        }

        const objectUrl = window.URL.createObjectURL(blobby);
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.href = objectUrl;
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(anchor);

        dispatch({
          type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_ALL_PROGRESS,
        });
      })
      .catch((error) => {
        dispatch(notificationActions.enqueueErrorResponse(error));
        dispatch({
          type: UPDATE_ACCUMULATED_CSV_DOWNLOAD_ALL_PROGRESS,
        });
      });
  };
}

function getStackMapInfoById(stackId: string) {
  return (dispatch: AppDispatch) => {
    dispatch({ type: UPDATE_STACK_MAP_INFO }); // clear
    ApiService.getStackMapInfoById(stackId)
      .then((response) => {
        dispatch({ type: UPDATE_STACK_MAP_INFO, mapInfo: response?.data });
      })
      .catch((error) => {
        dispatch(notificationActions.enqueueErrorResponse(error));
      });
  };
}

function updateStackFilterOptions(
  filterOptions?: StackFilterOptionsResponse | null,
) {
  return { type: UPDATE_STACK_FILTER_OPTIONS, filterOptions };
}

function updateStackList(
  stacks: ListStacksResponseItemPaginatedResponse | null,
  filters?: StackQueryRequest,
) {
  return { type: UPDATE_STACK_LIST, stacks, filters: filters ?? {} };
}

function updateStackMeasurementCard(
  measurementCard?: MeasurementCardResponse | null,
): UpdateStackMeasurementCard {
  return { type: UPDATE_STACK_MEASUREMENT_CARD, measurementCard };
}

function getOrganizationMeasurementCard(orgId: string) {
  return (dispatch: AppDispatch) => {
    dispatch(updateStackMeasurementCard(undefined)); // indicate loading
    ApiService.getOrganizationMeasurementCard(orgId)
      .then((response) => {
        dispatch(updateStackMeasurementCard(response.data));
      })
      .catch((error) => {
        dispatch(updateStackMeasurementCard(null));
        dispatch(notificationActions.enqueueErrorResponse(error));
      });
  };
}

function refreshStacks() {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    dispatch(getStacks(getState().stacks.filters));
  };
}

function getStacksForSawmillUser(filters: StacksBySawmillQueryPagedRequest) {
  return (dispatch: AppDispatch) => {
    // TODO: do not request new coordinates if pagination is the only filter change
    if (filters.from && filters.to) {
      dispatch({
        type: SIGNAL_STACK_COORDINATES_LOADING,
      });
      ApiService.getSawmillStackMapList({ ...filters, page: 1, pageSize: 1000 }) // same filters but 1000 points
        .then((response) => {
          dispatch({
            type: UPDATE_STACK_COORDINATES,
            coordinates: response?.data?.data ?? [],
          });
        })
        .catch((error) => {
          dispatch(notificationActions.enqueueErrorResponse(error));
          dispatch({
            type: UPDATE_STACK_COORDINATES,
            coordinates: [],
          });
        });

      dispatch({
        type: SIGNAL_STACK_LIST_LOADING,
      });
      const stackQueryRequest: StackQueryRequest = {
        sawmillIds: filters.sawmillIds,
        from: filters.from,
        to: filters.to,
        departmentIds: filters.departmentIds ?? [],
      };
      ApiService.getSawmillStackList(filters)
        .then((response) => {
          dispatch(updateStackList(response.data, stackQueryRequest));
        })
        .catch((error) => {
          dispatch(notificationActions.enqueueErrorResponse(error));
          dispatch(updateStackList(null, stackQueryRequest));
        });
    }
  };
}

function getStackFilterOptions(filters: StackFilterOptionsQueryRequest) {
  return (dispatch: AppDispatch) => {
    // dispatch(updateStackFilterOptions(undefined)); // signal loading
    ApiService.getStackFilterOptions(filters)
      .then((response) => {
        dispatch(updateStackFilterOptions(response.data));
      })
      .catch((error) => {
        dispatch(updateStackFilterOptions(null)); // signal no data
        dispatch(notificationActions.enqueueErrorResponse(error));
      });
  };
}

function getStacks(filters?: IStackQuery) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    if (
      filters?.departmentIds &&
      filters.departmentIds.length > 0 &&
      filters.dateType
    ) {
      if (filters.from && filters.to) {
        const prevFilters = getState().stacks.filters;
        if (
          !prevFilters ||
          prevFilters.from !== filters.from ||
          prevFilters.to !== filters.to ||
          prevFilters.departmentIds !== filters.departmentIds
        ) {
          dispatch(
            getStackFilterOptions({
              from: filters.from,
              to: filters.to,
              departmentIds: filters.departmentIds,
            }),
          );
        }
      }

      if (filters.showMap === 'true') {
        // TODO: do not request new coordinates if pagination is the only filter change
        dispatch({
          type: SIGNAL_STACK_COORDINATES_LOADING,
        });
        ApiService.getStackMapList({ ...filters, page: 1, pageSize: 10000 }) // same filters but 10000 points
          .then((response) => {
            dispatch({
              type: UPDATE_STACK_COORDINATES,
              coordinates: response?.data?.data ?? [],
            });
          })
          .catch((error) => {
            dispatch(notificationActions.enqueueErrorResponse(error));
            dispatch({
              type: UPDATE_STACK_COORDINATES,
              coordinates: [],
            });
          });
      }
      dispatch({
        type: SIGNAL_STACK_LIST_LOADING,
      });
      ApiService.getStackList(filters)
        .then((response) => {
          dispatch(updateStackList(response.data, filters));
        })
        .catch((error) => {
          dispatch(notificationActions.enqueueErrorResponse(error));
          dispatch(updateStackList(null, filters));
        });
    } else {
      // no deptId => clear stack list
      dispatch(updateStackList(null, filters));
      dispatch({
        type: UPDATE_STACK_COORDINATES,
        coordinates: [],
      });
      dispatch(updateStackFilterOptions(null));
    }
  };
}

function getStackById(stackId: string) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_STACK,
    });

    ApiService.getStackById(stackId)
      .then((response) => {
        dispatch({
          type: UPDATE_STACK,
          stack: response.data,
        });
      })
      .catch((error) => {
        dispatch(notificationActions.enqueueErrorResponse(error));
        dispatch({
          type: STACK_ERROR,
        });
      });
  };
}

function deleteStackById(stackId: string) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: STACK_DELETE,
      stackId: stackId,
    });
    ApiService.deleteStack(stackId)
      .then(() => {
        dispatch({
          type: STACK_DELETE_SUCCESS,
          stackId: stackId,
        });
      })
      .catch((error) => {
        dispatch(notificationActions.enqueueErrorResponse(error));
        dispatch({
          type: STACK_DELETE_ERROR,
          stackId: stackId,
        });
      });
  };
}
